<template>
  <div>
    <div @click="chiudi()" v-if="obj!=null" class="form d-flex align-items-center justify-content-center">
      <transition
        v-on:after-enter="daiFocus()"
        name="custom"
        v-on:after-leave="esci()"
        enter-active-class="swal2-show"
        leave-active-class="swal2-hide"
      >
        <div @click.stop v-if="mostraInserimento" class="evidenzia container" style="background-color:white;">
          <div class="row intestazione">
            <div class="col-12 text-center my-auto">Prezzo Sostituzione {{ obj.value }} {{ obj.modello }}</div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-4 d-flex align-items-center justify-content-center">
                 <imageLoader :imgInfo="obj"></imageLoader>
              </div>
              <div class="col-8 d-flex blocco align-items-center justify-content-center">
                <div>
                  <label style="float:right;">Prezzo Riparazione</label>
                  <money id="price" class="money" autocomplete="disabled" v-model="prezzo" v-bind="money"></money>
                  <label style="float:right;">Costo Ricambio</label>

                  <money disabled  class="money-2" autocomplete="disabled" v-model="this.costo" v-bind="money"></money>

                  <label style="float:right;">Utile</label>
                  <money disabled class="money-2 verde" autocomplete="disabled" v-model="utile" v-bind="money"></money>
                </div>
              </div>
            </div>
          </div>
          <div class="row add">
            <div class="col-8 d-flex align-items-center text-center my-auto">
              <input type="checkbox">
              <span class="mostra">Mostra automaticamente questo box</span>
            </div>

            <div class="col-4 d-flex align-items-center justify-content-center">
              <div @click="save()" class="tasto">Salva</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../main.js";
import { db } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";
import { jStore } from "../store/jestionaleStore.js";
import { mapState, mapGetters } from "vuex";
import Vue from "vue";
import { Money } from "v-money";

export default {
  name: "inserimentoPrezzo",
  directives: {},
  data() {
    return {
      prezzo: _.get(this.obj, 'prezzo', '0'),
      costo: _.get(this.obj.stock, 'costo', '0'),
      mostraInserimento: false,
      //VARIABILI AMBIENTE
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: " €",
        precision: 2,
        masked: false
      }
    };
  },
  components: {
    Money
  },
  props: ["obj"],
  computed: {
    utile(){
        let risultato
        if (!(this.prezzo>0)){return '0'}
        let prezzo = parseFloat(this.prezzo)
        let costo = parseFloat(this.costo)
        if(!(costo>0)){return '0'} //SE NON C'è IL COSTO NON CALCOLO L'ULTILE
        risultato = ( prezzo / 1.22) - costo
        if(risultato>0)return risultato //MOSTRO SOLO SE MAGGIORE DI ZERO
    }
  },
  methods: {
    save(){
        let obj = this.obj
        obj.prezzo = this.prezzo
         //SE ARRIVA DAL NODO ESTERNO LO CLONO (VA MESSA IN INSERIMENTO PREZZO)
        if (obj.parent === 'ricambi' && obj.fonte === 'esterno') {
             this.$store.dispatch("ordineStates/cloneToNodoInterno", obj);
        }
        if (obj.parent === 'ricambi' && obj.fonte === 'interno') {
             var payload = {
            obj: obj.id,
            price: this.prezzo
        };
             this.$store.dispatch("ordineStates/updatePriceInDB", payload);
        }
        this.$emit('saved', obj)
        //this.$store.dispatch("ordineStates/addToCart", obj);
        this.chiudi()
    },
    daiFocus() {
      price.focus();
    },
    chiudi() {
      this.mostraInserimento = false;
    },
    esci() {
      this.$emit('closed')  
    }
  },
  mounted() {
    let self = this;
    Vue.nextTick(function() {
      self.mostraInserimento = true;
      //if(self.obj.prezzo>0){ self.prezzo = self.obj.prezzo}
  
    });
  },
  watch: {}
};
</script>

<style scoped>
.verde{
color: #00801e !important

}
.blocco {
  padding-top: 4vh;
  padding-bottom: 4vh;
}
.consegna {
  padding-top: 2vh;
  padding-left: 2vw;
  width: 100%;
  height: 6vh;
  margin-bottom: 2vh;
}

.mostra {
  margin-left: 1vw;
  font-weight: 10;
  font-size: 1.5vh;
  color: darkgray;
}

.info {
  margin-left: 10px;
  padding: 0.5vh;
  font-size: 10px;
  font-weight: 10;
  color: #7f8c8d;
}

.tasto {
  padding-left: 4.2vh;
  padding-right: 4.2vh;
  padding-top: 0.5vh;
  padding-bottom: 0.5vh;
  background-color: #27ae60;
  color: white;
  cursor: pointer;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  position: relative;
}

.add {
  height: 7vh;
  background-color: white;
  font-weight: bold;
  font-size: 1.7vh;
  -webkit-border-bottom-right-radius: 9px;
  -webkit-border-bottom-left-radius: 9px;
  -moz-border-radius-bottomright: 9px;
  -moz-border-radius-bottomleft: 9px;
  border-bottom-right-radius: 9px;
  border-bottom-left-radius: 9px;
}

.form {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 9999;
  height: 100%;
  width: 100%;
}

.scadenza:focus {
  outline: none;
}

.form > div {
  width: 29vw;
  background-color: white;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  overflow: hidden;
}

.form input:not([type="checkbox"]) {
  padding-left: 1vw;
  height: 5vh;
  width: 100%;
  border: none;
  border-bottom: solid 2px #f3f3f3;
  transition: all 0.2s;
  margin-bottom: 1vh;
  text-align: left;
  padding-right: 7px;
}

.money {
  text-align: right !important;
}

.money-2 {
  background-color: #e0e0e0 !important;
  text-align: right !important;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

.form input:not([type="checkbox"]):focus {
  outline: none;
  border-bottom: solid 2px #007bff;
}

.form label {
  font-size: 1.7vh;
  color: #848484;
  margin-top: 1vh;
  margin-right: 1vh;
  margin-bottom: 0vh;
}

.intestazione {
  height: 6vh;
  background-color: #595959;
  color: white;
  font-weight: bold;
  font-size: 1.7vh;

  -webkit-border-radius: 9px;
  -webkit-border-bottom-right-radius: 3px;
  -webkit-border-bottom-left-radius: 3px;
  -moz-border-radius: 9px;
  -moz-border-radius-bottomright: 3px;
  -moz-border-radius-bottomleft: 3px;
  border-radius: 9px;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.select {
  overflow: hidden;
  position: relative;
  border-radius: 3px;
  margin-bottom: 1em;
}

.select:after {
  content: "▼";
  display: flex;
  align-items: center;

  position: absolute;
  right: 1.5vw;
  top: 0;
  z-index: 1;
  text-align: center;
  height: 100%;
  pointer-events: none;
  font-size: 1.6vh;
  color: #5e5e5e;
}

.select__field {
  margin-right: 1vw;
  border: 0;
  background-color: #e6e6e6;
  padding-left: 1.5vw;
  padding-right: 2.2vw;
  -webkit-appearance: none; /* remove the strong OSX influence from Webkit */
  height: 5vh;

  color: #616263;

  outline: none;
  border: none;

  -webkit-appearance: none;
  /* for webkit browsers */
  -moz-appearance: none;
  /* for firefox */
  appearance: none;
  /* for modern browsers */
}

/* remove default caret for ie */

.select__field::-ms-expand {
  display: none;
}
</style>
